export class EmailService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async sendMail(mail) {
        const response = await this.apiService.post('email', mail);
        if (response.status === 200) {
            return true;
        }
    }
}
